import schLogoProxy from '../enquiry/carrier-logo'
export default schLogoProxy
